export default __webpack_public_path__ + "static/media/pusher.aec299c8.svg";